import type { HecProduct } from "~/hec/types/product";
import { rewriteSfccContentLinks } from "~/hec/utils/sfcc-content-links";

type Promotion = NonNullable<HecProduct["productPromotions"]>[number];

/**
 * Native SFCC promotion callouts rendered above the price block.
 * Each callout uses `calloutMsg` when present, falling back to `details`.
 * Callouts are HTML — sanitization is the loader's responsibility.
 *
 * SFCC-11041 / PDP-MERCH-02. Hybrid PDP uses a distinct testId so the smoke
 * suite can target the compact variant separately.
 */
export function PromotionCallouts({
  promotions,
  testId = "pdp-promotion-callouts",
}: {
  promotions: Promotion[] | undefined;
  testId?: string;
}) {
  if (!promotions?.length) return null;

  const visible = promotions.filter(
    promotion => promotion.calloutMsg || promotion.details,
  );
  if (visible.length === 0) return null;

  return (
    <div className="mb-1" data-testid={testId}>
      {visible.map(promotion => (
        <div
          key={promotion.promotionId}
          className="text-sm"
          dangerouslySetInnerHTML={{
            __html: rewriteSfccContentLinks(
              (promotion.calloutMsg || promotion.details) as string,
            ),
          }}
        />
      ))}
    </div>
  );
}
